import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function AdminLoginPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const res = await fetch('/api/auth/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password }),
      });
      const data = await res.json();

      if (!res.ok) {
        throw new Error(data.error || 'Login failed');
      }

      if (!['admin', 'operator'].includes(data.user.role)) {
        throw new Error('Access denied. Operator or admin account required.');
      }

      localStorage.setItem('adminToken', data.token);
      localStorage.setItem('adminUser', JSON.stringify(data.user));
      navigate('/admin');
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.wrapper}>
      <div style={styles.card}>
        <div style={styles.logoBox}>
          <div style={styles.logoIcon}>H</div>
          <h1 style={styles.title}>Horizon Admin</h1>
          <p style={styles.subtitle}>Operator Panel</p>
        </div>

        {error && <div style={styles.error}>{error}</div>}

        <form onSubmit={handleSubmit}>
          <div style={styles.field}>
            <label style={styles.label}>Email</label>
            <input type="email" value={email} onChange={(e) => setEmail(e.target.value)}
              placeholder="operator@horizonrecruitmentltd.co.uk"
              style={styles.input} required autoFocus />
          </div>
          <div style={styles.field}>
            <label style={styles.label}>Password</label>
            <input type="password" value={password} onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••" style={styles.input} required />
          </div>
          <button type="submit" disabled={loading} style={{
            ...styles.btn, opacity: loading ? 0.7 : 1,
          }}>
            {loading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>

        <p style={styles.back}>
          <a href="/" onClick={(e) => { e.preventDefault(); navigate('/'); }}
            style={{ color: '#6c757d', textDecoration: 'none' }}>
            ← Back to website
          </a>
        </p>
      </div>
    </div>
  );
}

const styles = {
  wrapper: {
    minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
    background: 'linear-gradient(135deg, #1a2f4d 0%, #0d1b2e 100%)',
    padding: '20px',
  },
  card: {
    background: '#fff', borderRadius: '12px', padding: '40px', width: '100%', maxWidth: '420px',
    boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
  },
  logoBox: { textAlign: 'center', marginBottom: '30px' },
  logoIcon: {
    width: '60px', height: '60px', background: '#ff6b35', color: '#fff', borderRadius: '12px',
    display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
    fontSize: '28px', fontWeight: 800, fontFamily: 'Montserrat, sans-serif', marginBottom: '15px',
  },
  title: { fontSize: '24px', fontWeight: 700, color: '#1a2f4d', margin: '0', fontFamily: 'Montserrat, sans-serif' },
  subtitle: { fontSize: '14px', color: '#6c757d', margin: '5px 0 0' },
  field: { marginBottom: '20px' },
  label: { display: 'block', fontSize: '14px', fontWeight: 600, color: '#1a2f4d', marginBottom: '6px' },
  input: {
    width: '100%', padding: '12px 15px', border: '2px solid #e9ecef', borderRadius: '8px',
    fontSize: '15px', outline: 'none', transition: 'border 0.2s', boxSizing: 'border-box',
  },
  btn: {
    width: '100%', padding: '14px', background: '#ff6b35', color: '#fff', border: 'none',
    borderRadius: '8px', fontSize: '16px', fontWeight: 700, cursor: 'pointer',
    fontFamily: 'Montserrat, sans-serif',
  },
  error: {
    background: '#fee', color: '#d33', padding: '12px', borderRadius: '8px',
    marginBottom: '20px', fontSize: '14px', textAlign: 'center',
  },
  back: { textAlign: 'center', marginTop: '20px', fontSize: '14px' },
};
